export default __webpack_public_path__ + "static/media/arrow-down.7e78197e.svg";